export default "__VITE_ASSET__CjLJbM$I__"